import { Goal } from '@griply/types';

import { getGoalAchievedPercentage } from './get-goal-achieved-percentage';

export const hasGoalReachedTarget = (goal: Goal, goals: Goal[]): boolean =>
  (getGoalAchievedPercentage(goal, goals) ?? 0) >= 100;
